import http from './httpService';
import {t, getLanguage} from "react-switch-lang";


const nameValue = getLanguage() === "eng" ? "nameEn" : "name";

export function getAllSubRisksCauses() {
  return http.get(`/risk-sub-causes?sort=${nameValue}`);
}

export function updateSubRisksCauses(payload) {
  return http.put('/risk-sub-causes', payload);
}

export function createSubRisksCauses(payload) {
  return http.post('/risk-sub-causes', payload);
}

export function deleteSubRisksCauses(id) {
  return http.delete(`/risk-sub-causes/${id}`);
}
export async function getAllRisksCauses(page = 0, result = []) {
  const { data } = await http.get(
    `/risk-causes?page=${page}&size=20&sort=${nameValue}`
  );

  result.push(...data);

  return data?.length < 20
    ? { data: result }
    : getAllRisksCauses(page + 1, result);
}